module.exports = __webpack_public_path__ + "static/media/gray-center-divider.c36db75b.png";